import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

function getMedia(mediaWrapper) {
    if (mediaWrapper) {
        if (mediaWrapper.hasAttribute('data-type')) {
            return mediaWrapper.getAttribute('data-type');
        } else {
            console.log('ERROR: Invalid media type');
        }
    } else {
        console.log('ERROR: Missing media wrapper');
    }
}

document.addEventListener(
    "DOMContentLoaded",function() {
    document.querySelectorAll('.js-banner-fixed-scroll').forEach(item => {
        const banner       = item;
        const mediaWrapper = banner.querySelector('.fs-media-wrapper');
        const media        = getMedia(mediaWrapper);
        const overlay      = document.createElement('div');

        mediaWrapper.appendChild(overlay);
        overlay.classList.add('fixed-scroll-fader-overlay'); // Create a separate overlay for the scroll event
        overlay.setAttribute('role', 'presentation');
        gsap.set(overlay, { opacity: 0 });

        if (undefined !== media) {
            if (media === 'image') {
                let mediaElem = mediaWrapper.querySelector('img[itemprop="image"]');
                gsap.set(mediaElem, { opacity: 0 });
                imagesLoaded(banner, () => {
                    gsap.to(mediaElem, { opacity: 1, duration: 2, ease: 'power1.out' });
                });
            }
            gsap.timeline({
                scrollTrigger: {
                    trigger: banner,
                    start: 'top top',
                    end: 'bottom top',
                    pin: true,
                    pinSpacing: false,
                    scrub: true
                }
            })
            .to(overlay, {
                opacity: 1
            });
        } else {
            console.log('ERROR: Invalid media type');
        }
    });
});
